<app-templates-carousel class="carousel" [carouselData]="carouselDataList$ | async"> </app-templates-carousel>
